import { FC } from 'react';
import { observer } from 'mobx-react';
import { Card, Chip } from '@servicetitan/anvil2';
import { core } from '@servicetitan/anvil2/token';
import { TitleValue, TitleWithValueComponent } from './common/title-value';
import classNames from 'classnames';
import { TxvSizeCalculatorResponseDto } from '../../models/txv-size-calculator.response.dto';

export const TxvSizeCalculatorAnswer: FC<{
    data: TxvSizeCalculatorResponseDto;
    className?: string;
}> = observer(({ data, className }) => {
    const chipColor = core.primitive.ColorRed100.value;
    const chipLabel = data.title;

    return (
        <Card className={classNames('w-100-i', className)}>
            <div
                style={{
                    flexGrow: '1',
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    rowGap: 12,
                }}
            >
                <TitleWithValueComponent
                    title="result"
                    value={<Chip size="small" color={chipColor} label={chipLabel} />}
                />
                <TitleValue title="description" value={data.text} />
            </div>
        </Card>
    );
});
